import { Svg, View, Line, Text } from "@react-pdf/renderer";
import { styles } from "./styles";

export const Footer = ({ createdAt }) => {
	return (
		<View fixed style={styles.footer}>
			<Svg style={styles.footerLine}>
				<Line
					x1="0"
					y1="0"
					x2="800"
					y2="0"
					strokeWidth={1.5}
					stroke={"#000000"}
				/>
			</Svg>
			<View style={styles.footerText}>
				<Text>{`${createdAt}`}</Text>
				<Text
					render={({ pageNumber, totalPages }) =>
						`Página: ${pageNumber}/${totalPages}`
					}
				/>
			</View>
		</View>
	);
};
